import { SEO } from "@/components/seo";
import { ImageProps } from "@/components/shot";
import { Urls, capitalize } from "@/util";
import { PropsWithChildren } from "react";

type SEOProps = {
    season: {
        code: string
        recordingCountries: string|null
        image: ImageProps|null
        summary: string|null
        readonly participants: readonly
            {
                biography: {
                    firstName: string
                    lastName: string|null
                }
            }[]
        
    }
    titlePrefix?: string
}

export default function SeasonSEO({ season, children, titlePrefix } : PropsWithChildren<SEOProps>) {
    const mainTitle = `seizoen ${season.code} (${season.recordingCountries}) van Wie is de Mol`
    const title = (titlePrefix != undefined) ? (titlePrefix + ' ' + mainTitle) : capitalize(mainTitle)
    return <SEO canonicalUrl={Urls.season(season.code)} title={title} description={season.summary!} image={season.image!}>
        <meta property="og:type" content="video.tv_show" />
        {season.participants.map(p => <>
            <meta property="og:video:actor:first_name" content={p.biography.firstName}/>
            {p.biography.lastName && <meta property="og:video:actor:last_name" content={p.biography.lastName}/>}
        </>)}
        {children}
    </SEO>
}